import { FullScreenModal } from '@pata-app/ui-modal';

import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AppointmentItem } from '../../../../../components/appointment-item/appointment-item';
import { Button } from '../../../../../components/button/button';
import Icon from '../../../../../components/icon/icon';
import { Loader } from '../../../../../components/loader/loader';
import Popup from '../../../../../components/popup/popup';
import useForm from '../../../../../hooks/useForm/useForm';
import { queryClient } from '../../../../../main';
import { useGetBusiness } from '../../../../../queries/business.queries';
import BusinessReviews from '../businessReviews';
import { useGetAddReview, useGetReviewToken, usePostBusinessReview } from '../businessReviews.queries';
import { writeReviewValidationConfig } from './addReview.config';
import { AddReviewContainer } from './addReview.styled';
import { AddReviewForm } from './addReviewForm';

const AddReview = () => {
  const navigate = useNavigate();

  const { id, reviewToken } = useParams();

  const { data: businessData } = useGetBusiness(id);

  const mutation = usePostBusinessReview(id, businessData?.accountId);

  const { data, isError } = useGetReviewToken(id, reviewToken, businessData?.accountId, {
    enabled: Boolean(reviewToken && id && businessData?.accountId),
  });

  useEffect(() => {
    if (isError) {
      navigate(`/p/${id}`);
    }
  }, [isError]);

  const reviewTokenData = data?.data.data;

  const form = useForm(writeReviewValidationConfig, {
    rating: null,
    text: '',
  });

  const rating = form.formState.rating;

  const handlePublishReview = () => {
    if (form.isFormValid) {
      const formData = form.getFormState();

      mutation.mutate(
        { text: formData.text?.trim() || undefined, rating: formData.rating, token: reviewToken },
        {
          onSuccess: () => {
            setTimeout(() => {
              queryClient.invalidateQueries(['businessProfile', id]);

              navigate(`/p/${id}`);
            }, 2000);
          },
        },
      );
    }
  };

  const handleToggleModal = () => {
    navigate(`/p/${id}`);
  };

  return (
    <FullScreenModal
      isOpen={true}
      modalTitle={`Add review for ${businessData?.name}`}
      handleToggleModal={handleToggleModal}
      actions={[]}
    >
      {!reviewTokenData ? (
        <Loader addPadding={false} />
      ) : (
        <AddReviewContainer>
          <AppointmentItem appointment={{ ...reviewTokenData?.appointment, workplace: reviewTokenData?.workplace }} />
          <AddReviewForm businessName={businessData?.name} form={form} setShowAddReview={handleToggleModal} />
          <Button disabled={!rating} isLoading={mutation.isLoading} onClick={handlePublishReview}>
            Submit
          </Button>
        </AddReviewContainer>
      )}
    </FullScreenModal>
  );
};

export default AddReview;
